export const DURATION = 2
